export const VisuallyImpairedKey = 'Helix.VisuallyImpaired';
